import { atom } from "@mongez/react-atom";
import { Address } from "../types";

export const addressesAtom: any = atom<Address[]>({
  key: "addresses",
  default: [],
});
